import { IExtensionsSiteSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateExtensionsSiteSettingsParams {
  siteSettings: IExtensionsSiteSettings;
}

export type IUpdateExtensionsSiteSettingsResult = IResult & IExtensionsSiteSettings;

export class UpdateExtensionsSiteSettingsRequest extends Request<IUpdateExtensionsSiteSettingsParams, IUpdateExtensionsSiteSettingsResult> {
  constructor(params: IUpdateExtensionsSiteSettingsParams) {
    super('updateExtensionsSiteSettings', params);
  }
}
